<template>
  <div
    class="mb-6"
    :class="$style['label-color']"
  >
    <label class="flex items-center">
      <VCheckbox
        name="checkCommercial"
        v-model="checkCommercial"
        :valid="isValid"
        :invalid="isInvalid"
        :error="validationError"
        @change="onChange"
        class="sm:mr-4"
      />
      <span class="ml-2 text-sm text-secondary-grey">
        ¿Quieres seguir manteniendo el contacto con nosotros aceptando informarte de novedades, productos y servicios, e incluso invitarte a eventos exclusivos de la marca. ¿Te parece bien?
      </span>
    </label>
  </div>
</template>

<script>
// import { required } from 'vuelidate/lib/validators'

import {
  VCheckbox
} from '@c/base'

export default {
  components: {
    VCheckbox
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    backValidationError: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      checkCommercial: this.value
    }
  },

  computed: {
    validationError () {
      if (this.backValidationError) {
        return this.backValidationError
      }

      if (this.$v.checkCommercial.$error && !this.$v.checkCommercial.required) {
        return this.$t('validate.required', { attribute: this.$t('attributes.checkCommercial') })
      }

      return ''
    },

    isValid () {
      return !this.backValidationError &&
             !this.$v.checkCommercial.$error &&
             this.$v.checkCommercial.required
    },

    isInvalid () {
      return !!this.backValidationError ||
             this.$v.checkCommercial.$error
    }
  },

  methods: {
    onChange () {
      this.$v.checkCommercial.$touch()
      this.$emit('input', this.checkCommercial)
    }
  },

  validations: {
    checkCommercial: {
      // required
    }
  }
}
</script>

<style module>
.label-color {
  color: #989898;
}
</style>
